import gbAntSelectRangePicker from "./src/gb-ant-select-range-picker.vue";
const gbAntSelectRangePickerCompenet = function(Vue) {
  Vue.component(gbAntSelectRangePicker.name, gbAntSelectRangePicker);
};
export default gbAntSelectRangePickerCompenet;
